module.exports = __webpack_public_path__ + "img/delete.841c19a8.svg";